/* eslint-disable @typescript-eslint/no-non-null-assertion */ function camelToSnakeCase(str) {
    return str.replaceAll(/[A-Z]/g, (letter)=>`_${letter.toLowerCase()}`);
}
export function camelToSnakeCaseObject(obj) {
    const result = {};
    for (const key of Object.keys(obj)){
        const newKey = camelToSnakeCase(key);
        const val = obj[key];
        result[newKey] = val;
    }
    return result;
}
